import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';

import {
  labelStyle,
  responsiveFun,
  stroke,
  lineXaxis,
  DownloadButton,
  markers,
  getColours,
} from '../options';
import dict from '../../dictionary';
import trans from '../../translations.json';
import { ButtonGroup } from '../buttonGroup/buttonGroup';
import LegandCheckbox from '../legandCheckbox/legandCheckbox';
import LTCTotalDeathsTable from './ltcTotalDeaths-Table';
import ReducedData from '../../reducedData.json';
import { ToolTipClone } from '../toolTipClone/toolTipClone';
import { renderToString } from 'react-dom/server';
import { dateFormater } from '../utils';
var MLTCData = Object.values(ReducedData.dataMLTCsummary);
const viewModes = {
  graph: 'graph',
  table: 'table',
};

const colors = getColours(['death', 'staff']);

var cData,
  chartData,
  totalresidentdata,
  totalstaffdata;

class LTCTotalDeaths extends Component {
  state = {
    ready: false,
    dates: [],
    series: [],
    options: {},
    selectedViewMode: viewModes.graph,
    chartRef: React.createRef(null),
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lang !== this.props.lang) {
      this.setData();
    }
  }

  toggle = (name) => {
    this.state.chartRef.current.chart.toggleSeries(name);
    if (this.state.chartRef.current.chart.series.w.globals.noData) {
      this.state.chartRef.current.chart.updateOptions({
        xaxis: {
          labels: {
            show: false,
          },
        },
        responsive: responsiveFun().map((item) => {
          item.options.yaxis.title.text =
            trans.ltc.ltcDeathsYaxis[this.props.lang];
          item.options.xaxis = {
            labels: {
              show: false,
            },
          };
          return item;
        }),
      });
    } else {
      this.state.chartRef.current.chart.updateOptions({
        xaxis: {
          labels: {
            show: true,
          },
        },
        responsive: responsiveFun().map((item) => {
          item.options.yaxis.title.text =
            trans.ltc.ltcDeathsYaxis[this.props.lang];
          item.options.xaxis = {
            labels: {
              show: true,
            },
          };
          return item;
        }),
      });
    }
  };

  prepData = () => {
    cData = [...MLTCData];
    chartData = cData.filter(
      (item) => item[dict.mltc_total_residents_deaths],
    );
    chartData = chartData.sort(function (a, b) {
      return (
        new Date(b[dict.reportedDate]) -
        new Date(a[dict.reportedDate])
      );
    });

    let staffChartData = [...chartData];
    totalresidentdata = chartData
      .map((item, z) => {
        if (
          item[dict.mltc_total_residents_deaths] &&
          item[dict.reportedDate]
        ) {
          return [
            item[dict.reportedDate],
            item[dict.mltc_total_residents_deaths],
          ];
        } else {
          return [
            item[dict.reportedDate],
            chartData[z - 1][dict.mltc_total_residents_deaths],
          ];
        }
      })
      .filter((item) => item !== undefined);
    totalstaffdata = staffChartData
      .map((item, z) => {
        if (
          item[dict.mltc_total_staff_deaths] !== null &&
          item[dict.mltc_total_staff_deaths] !== '<50' &&
          item[dict.reportedDate]
        ) {
          return [
            item[dict.reportedDate],
            Number(item[dict.mltc_total_staff_deaths]),
          ];
        } else if (
          item[dict.mltc_total_staff_deaths] !== null &&
          item[dict.mltc_total_staff_deaths] === '<50' &&
          item[dict.reportedDate]
        ) {
          return [item[dict.reportedDate], 4];
        } else {
          let todayStaffTotal;
          if (
            chartData[z - 1][dict.mltc_total_staff_deaths] !== null
            //&&
            //chartData[z - 1][dict.mltc_total_staff_deaths] !== '<50'
          ) {
            todayStaffTotal = Number(
              chartData[z - 1][dict.mltc_total_staff_deaths],
            );
            return [item[dict.reportedDate], todayStaffTotal];
          } else {
            return [item[dict.reportedDate], 0];
          }
        }
      })
      .filter((item) => item !== undefined);
  };

  setData = () => {
    const lang = this.props.lang;
    this.prepData();

    this.setState({
      series: [
        {
          name: trans.ltc.ltcResidents[lang],
          data: totalresidentdata,
          type: 'area',
        },
        {
          name: trans.ltc.ltcStaff[lang],
          data: totalstaffdata,
          type: 'line',
        },
      ],
      options: {
        colors: colors,
        markers: markers,
        stroke: stroke,
        legend: {
          show: false,
        },
        tooltip: {
          followCursor: true,
          style: { ...labelStyle },
          custom: function ({ series, dataPointIndex, w }) {
            let toolTipValue =
              series[1][dataPointIndex] === 4
                ? '< 5'
                : series[1][dataPointIndex];
            if (w.globals.collapsedSeriesIndices[0] === 0) {
              const tooltipTitle = () => {
                return dateFormater(
                  w.globals.initialSeries[1].data[dataPointIndex][0],
                );
              };
              let toolTipData = [
                {
                  label: w.globals.initialSeries[1].name,
                  value: toolTipValue,
                  colour: colors[1],
                },
              ];
              return renderToString(
                ToolTipClone(tooltipTitle(), toolTipData),
              );
            } else if (w.globals.collapsedSeriesIndices[0] === 1) {
              const tooltipTitle = () => {
                return dateFormater(
                  w.globals.initialSeries[0].data[dataPointIndex][0],
                );
              };
              let toolTipData = [
                {
                  label: w.globals.initialSeries[0].name,
                  value: series[0][dataPointIndex],
                  colour: colors[0],
                },
              ];
              return renderToString(
                ToolTipClone(tooltipTitle(), toolTipData),
              );
            } else if (
              w.globals.collapsedSeriesIndices.length === 0
            ) {
              const tooltipTitle = () => {
                return dateFormater(
                  w.globals.initialSeries[0].data[dataPointIndex][0],
                );
              };
              let toolTipData = [
                {
                  label: w.globals.initialSeries[0].name,
                  value: series[0][dataPointIndex],
                  colour: colors[0],
                },
                {
                  label: w.globals.initialSeries[1].name,
                  value: toolTipValue,
                  colour: colors[1],
                },
              ];
              return renderToString(
                ToolTipClone(tooltipTitle(), toolTipData),
              );
            }
          },
        },
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          zoom: { enabled: true },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: trans.ltc.ltcDeathsYaxis[this.props.lang],
          },
          labels: {
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            style: { ...labelStyle },
          },
        },
        xaxis: { ...lineXaxis(true) },
        responsive: responsiveFun().map((item) => {
          item.options.yaxis.title.text =
            trans.ltc.ltcDeathsYaxis[this.props.lang];
          item.options.xaxis = { ...lineXaxis(true) };
          return item;
        }),
        fill: {
          opacity: [0.5, 1],
        },
      },
      ready: true,
    });
  };

  render() {
    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <>
              <LegandCheckbox
                series={this.state.series}
                colours={colors}
                toggle={this.toggle}
              />
              <ReactApexChart
                ref={this.state.chartRef}
                options={this.state.options}
                series={this.state.series}
                height={this.props.height || '400px'}
                aria-hidden="true"
              />
              <span className="cviz-popup-status">
                <div style={{backgroundColor: '#9A76B9', marginRight: '5px'}}></div>
                <p dangerouslySetInnerHTML={{__html: trans.heatmap.dataAnomalies[this.props.lang] }} ></p>
              </span>
            </>
          );
        case viewModes.table:
          return (
            <LTCTotalDeathsTable
              data={chartData}
              lang={this.props.lang}
            />
          );
        default:
          break;
      }
    };
    return (
      <div id="">
        <p>{trans.ltc.descDeathsTotal[this.props.lang]}</p>
        {this.state.ready && (
          <>
            <ButtonGroup
              selected={this.state.selectedViewMode}
              viewModes={viewModes}
              lang={this.props.lang}
              handleOnClick={this.onViewModeChange}
            />
            <GetRightView />
          </>
        )}
      </div>
    );
  }
}

export default LTCTotalDeaths;
